import React from 'react';
import classNames from 'classnames';
import {View} from 'MWC';
import '../less/hoverItem.less';

class HoverItem extends View {
    constructor(props) {
        super(props);

        this.state = {
            name: props.name
        };
    }

    toggleHover() {
        this.props.toggleHover(!this.props.hover, this.props.alias);
    }

    render() {
        const {children, active, alias} = this.props,
            name = children.find(item => item && item.props && item.props.top),
            subMenuName = children.filter(item => {
                if (typeof item !== 'string' && item.length > 1) {
                    const subMenu = item.filter(item => item && item.props && !item.props.top);
                    return subMenu;
                } else {
                    return item && item.props && !item.props.top;
                }
            }),
            className = classNames('module-header-menu-item', this.props.className, {
                active: active === alias
            });
        return (
            <div
                className={className}
                onMouseEnter={this.toggleHover.bind(this)}
                onMouseLeave={this.toggleHover.bind(this)}
            >
                <span>{name}</span>
                {this.props.hover ? (
                    <div className={`toggle-items-wrapper ${alias}`}>
                        <div className={'toggle-items'}>{subMenuName}</div>
                    </div>
                ) : null}
            </div>
        );
    }
}

export default HoverItem;
